import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EditNatinalHoliday(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [tanggal, setTanggal] = React.useState(null);
    const [notes, setNotes] = React.useState("")
    const [status, setStatus] = React.useState("")
    const [id, setID] = React.useState("")
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorTanggal, setErrorTanggal] = React.useState(false);
    const [texterrorTanggal, setTextErrorTanggal] = React.useState(null);
    const [errorNotes, setErrorNotes] = React.useState(false);
    const [texterrorNotes, setTextErrorNotes] = React.useState(null);
    const [visibleConfirm, setVisibleConfirm] = React.useState(false);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    React.useEffect(() => {
        console.log(props);
        getDetailHoliday()
    }, [])

    const getDetailHoliday = () => {
        api.create().getDetailHoliday(props.id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setTanggal(new Date(data.date))
                    setNotes(data.notes)
                    setID(data.id)
                }
            }
        })
    }

    const doSubmit = (e) => {
        if (notes === "") {
            setErrorNotes(true)
            setTextErrorNotes("Catatan wajib diisi")
        } else {
            let payload = {
                "id": id,
                "notes": notes
            }
            console.log(payload);
            api.create().updateNationalHoliday(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Success")
                        props.onClose()
                        // props.refresh()
                        props.getData()
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("Warning")
                        }
                    }
                }
            })
        }
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Update Libur Nasional</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                    <div className="column-1">
                        <div style={{ margin: 0 }}>
                            <CustomDate
                                value={tanggal}
                                // minDate={new Date()}
                                required={true}
                                disabled={true}
                                onChange={(date) => {
                                    setTanggal(date)
                                    setErrorTanggal(false)
                                    setTextErrorTanggal("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <div>
                            <CustomTextField
                                required={true}
                                label={'Catatan'}
                                value={notes}
                                error={errorNotes}
                                helperText={texterrorNotes}
                                onChange={(val) => {
                                    setNotes(val)
                                    setErrorNotes(false)
                                    setTextErrorNotes("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => setVisibleConfirm(true)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {visibleConfirm && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleConfirm(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Reservasi yang sudah terbuat dari jadwal tersebut akan dibatalkan secara otomatis. Apakah anda ingin melanjutkan pembuatan jadwal libur nasional?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleConfirm(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => doSubmit()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}